import { Model, modelRegistry } from './Model';
import { GoodsIssueItem } from '.';
/**
 * GoodsIssue (Izdavanje robe): the read-only inventory-accounting outflow of an internal transfer, attached to
 * its dispatch. Totals (retail value = VAT + margin + purchase value) come from the API.
 */
export class GoodsIssue extends Model {
    static entity = 'goods_issues';
    id = null;
    user_id = null;
    number = null;
    warehouse_id = null;
    date = null;
    type = 'internal_transfer';
    description = null;
    recorded_at = null;
    counterparty_type = null;
    counterparty_id = null;
    counterparty = null;
    /** The source dispatch; register_type is set on an e-dispatch, which lives on the e-dispatches list. */
    dispatch = null;
    selling_value_after_tax = 0;
    tax_value = 0;
    margin_value = 0;
    purchase_value = 0;
    created_at = null;
    updated_at = null;
    items = [];
    warehouse = null;
    static fields() {
        return {
            id: this.attr(null),
            user_id: this.attr(null),
            number: this.attr(null),
            warehouse_id: this.attr(null),
            date: this.attr(null),
            type: this.attr('internal_transfer'),
            description: this.attr(null),
            recorded_at: this.attr(null),
            counterparty_type: this.attr(null),
            counterparty_id: this.attr(null),
            counterparty: this.attr(null),
            dispatch: this.attr(null, (value) => value ? { id: Number(value.id), number: String(value.number), register_type: value.register_type ?? null } : null),
            selling_value_after_tax: this.attr(0, value => Number(value) || 0),
            tax_value: this.attr(0, value => Number(value) || 0),
            margin_value: this.attr(0, value => Number(value) || 0),
            purchase_value: this.attr(0, value => Number(value) || 0),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            items: this.attr([], (value) => (value || []).map(item => new GoodsIssueItem(item))),
            warehouse: this.attr(null, (value) => value ? { id: Number(value.id), name: String(value.name) } : null),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    isRecorded() {
        return !!this.recorded_at;
    }
}
export default GoodsIssue;
modelRegistry.register('GoodsIssue', GoodsIssue);
//# sourceMappingURL=GoodsIssue.js.map